export default "__VITE_ASSET__7246f2cb__"